export const PORTAL_PERMISSIONS = {
	createOrders: 'portal.createOrders',
} as const;

export type TPortalPermission =
	typeof PORTAL_PERMISSIONS[keyof typeof PORTAL_PERMISSIONS];
